import { Center } from '@chakra-ui/layout';
import classNames from 'classnames';

import type { Position } from '../../PageConfigProvider/types/item';
import styles from '../EditableGrid.module.css';
import { useGrid } from '../GridProvider';
import type { GhostPlaceholder } from '../utils/ghost-layout-generator';

interface GhostPlaceholdersProps {
  ghosts: GhostPlaceholder[];
  onAddItem: (position: Position) => void;
}

export const GhostPlaceholders = ({
  ghosts,
  onAddItem,
}: GhostPlaceholdersProps) => {
  const { gridItems, edgeDragging } = useGrid();

  return (
    <>
      {ghosts.map((ghost, i: number) => (
        <Center
          key={ghost.id}
          minWidth="0"
          minHeight="0"
          style={{
            gridColumn: `${ghost.position.x + 1} / span ${ghost.position.width}`,
            gridRow: `${ghost.position.y + 1} / span ${ghost.position.height}`,
          }}
          backgroundColor="#FFFFFF80"
          borderRadius="var(--chakra-radii-md)"
          border="1px solid #E2E8F0"
          color="#1A202C"
          cursor="pointer"
          className={classNames(styles.addGhost, {
            [styles.edgeDragging ?? '']: edgeDragging,
            [styles.firstGhost ?? '']: i === 0 && gridItems.length === 0,
          })}
          onClick={() => onAddItem(ghost.position)}
        >
          + Create Chart
        </Center>
      ))}
    </>
  );
};
